<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<h3 class="mt-2">
  Prodotti e servizi salvati
  <!-- <mat-icon
    aria-hidden="false"
    aria-label="Example home icon"
    fontIcon="dataset"
  ></mat-icon> -->
</h3>
<p>Le prestazioni salvate saranno disponibili durante la creazione di nuove fatture o preventivi.</p>

<div class="mt-3 mb-3 d-flex justify-content-between align-items-center">
  <!-- chips -->
  <mat-chip-set aria-label="Filter selection" class="flex-grow-1 status-chip-set">
    <mat-chip-option 
      *ngFor="let option of filterOptions"
      [value]="option.value"
      [selected]="selectedFilter === option.value"
      (click)="applyTypeFilter(option.value)"
      >
      {{option.name}}
    </mat-chip-option>
      <!-- [value]="option.value"
      [selected]="selectedFilter === option.value"
      (click)="applyFilter(option.value)" -->
  </mat-chip-set>

  <button
    mat-raised-button
    color="primary"
    (click)="navigateToNewSavedProduct()"
    class="ms-3 flex-shrink-0 green-button"
    matButton="filled"
  >
    <mat-icon>add</mat-icon>
    <span>Nuovo</span>
  </button>
</div>

<mat-card class="mb-3 mb-md-0 col-md-12 d-flex flex-column custom-card izy-sharp-bl hidden-mobile">
  <mat-card-content>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
      <p class="mt-3">Caricando prodotti e servizi..</p>
    </div>

    <!-- Show empty state when no data -->
    <div *ngIf="savedProductSource.filteredData.length === 0 && !isLoading" class="empty-state text-center py-5">
      <img 
        src="izy_image_2.png" 
        alt="Nessun cliente"
        class="empty-state-image mb-3"
        style="max-width: 300px; opacity: 1;"
      >
      <h4 class="text-muted">Ops, niente da vedere qui.</h4>
      <p class="text-muted">Registra subito un prodotto o servizio!</p>
    </div>

    <table
      *ngIf="savedProductSource.filteredData.length > 0"
      mat-table
      [dataSource]="savedProductSource"
      class="mat-elevation-z8 hidden-mobile"
    >
      <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

      <!-- Actions -->
       <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef class="text-center">Azioni</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <button
            mat-icon-button
            class="izy-row-actions-btn"
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
            aria-label="Altre azioni"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu" class="izy-menu-panel" xPosition="before">
            <button mat-menu-item (click)="onRowClick(element)">
              <mat-icon>manage_search</mat-icon>
              <span>Vedi dettagli</span>
            </button>
            <div class="izy-menu-sep"></div>
            <!-- Add delete button only for ATTESA status -->
            <button
              mat-menu-item 
              (click)="deleteSavedProduct(element)"
              class="text-danger"
            >
              <mat-icon color="warn">delete</mat-icon>
              <span>Elimina</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">{{element.name}}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let element">{{element.type}}</td>
      </ng-container>

      <ng-container matColumnDef="units">
        <th mat-header-cell *matHeaderCellDef>Unità</th>
        <td mat-cell *matCellDef="let element">{{element.units}}</td>
      </ng-container>

      <ng-container matColumnDef="unit_price">
        <th mat-header-cell *matHeaderCellDef>Prezzo unitario</th>
        <td mat-cell *matCellDef="let element">{{ formatTableAmount(element.unit_price) }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Descrizione</th>
        <td mat-cell *matCellDef="let element">{{element.description}}</td>
      </ng-container>

      <ng-container matColumnDef="iva_percentage">
        <th mat-header-cell *matHeaderCellDef>Percentuale IVA</th>
        <td mat-cell *matCellDef="let element">{{element.iva_percentage}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        (click)="onRowClick(row)"
      ></tr>
    </table>

    <!-- <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons
      aria-label="Select page of companies"
    ></mat-paginator> -->
    <!-- Add the paginator at the bottom of the table -->

    <!-- *ngIf="savedProductSource.filteredData.length > 0" -->
    <mat-paginator
      
      [pageSizeOptions]="[10, 20, 50, 100]"
      [pageSize]="20"
      showFirstLastButtons
      [selectConfig]="{ panelClass: 'izy-select-panel' }"
      aria-label="Select page of products"
      class="hidden-mobile pt-2 pb-2"
    >
    </mat-paginator>

    <mat-divider class="visible-mobile"></mat-divider>
  </mat-card-content>
</mat-card>

<!-- Mobile Cards -->
<div class="mobile-cards visible-mobile">

  <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
      <p class="mt-3">Caricando prodotti e servizi...</p>
    </div>
  <!-- Empty state for mobile -->
  <div *ngIf="savedProductSource.filteredData.length === 0 && !isLoading" class="empty-state text-center py-5">
    <img 
      src="izy_image_2.png" 
      alt="Nessun cliente"
      class="empty-state-image mb-3"
      style="max-width: 250px; opacity: 1;"
    >
    <h4 class="text-muted">Ops, niente da vedere qui.</h4>
    <p class="text-muted">Registra subito un prodotto o servizio!</p>
  </div>

  <mat-card
    *ngFor="let item of savedProductSource.filteredData"
    class="izy-sharp-bl custom-card-border"
  >
    <mat-card-content>
      <div class="d-flex m-0 justify-content-between align-items-center">
      <h6><strong>{{item.name}}</strong></h6>
        <button
          mat-icon-button
          class="izy-row-actions-btn"
          [matMenuTriggerFor]="menu"
          aria-label="Altre azioni"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
          <mat-menu #menu="matMenu" class="izy-menu-panel" xPosition="before">
            <button mat-menu-item (click)="onRowClick(item)">
              <mat-icon>manage_search</mat-icon>
              <span>Vedi dettagli</span>
            </button>
            <!-- <button mat-menu-item (click)="navigateToNewSavedProduct()">
              <mat-icon>add_card</mat-icon>
              <span>Nuova fattura</span>
            </button> -->
            <!-- <button mat-menu-item disabled>
              <mat-icon>voicemail</mat-icon>
              <span>Check voice mail</span>
            </button> -->
            <div class="izy-menu-sep"></div>
            <button mat-menu-item (click)="deleteSavedProduct(item)" class="text-danger">
              <mat-icon color="warn">delete</mat-icon>
              <span>Elimina</span>
            </button>
          </mat-menu>
        </div>
      <p class="mb-1 text-small"><strong>Name:</strong> {{item.name}}</p>
      <p class="mb-1 text-small"><strong>Descrizione:</strong> {{item.description}}</p>
    </mat-card-content>

    <div class="d-flex mt-0 mb-0 justify-content-between align-items-center saved-product-card-footer">
      <mat-chip class="ms-1 status-chip" selected>
        {{item.type}}
      </mat-chip>

      <button
        mat-stroked-button
        (click)="onRowClick(item)"
        class="me-2 saved-product-details-btn custom-button-border"
      >
        <div class="d-flex justify-content-between align-items-center">
        <p class="mb-0">Apri</p>
        <span>
          <mat-icon class="ms-3 mt-1 m-0">chevron_right</mat-icon>
        </span>
        </div>
      </button>
    </div>
  </mat-card>

  <!-- <mat-paginator
    *ngIf="savedProductSource.filteredData.length > 0"
    [pageSizeOptions]="[5, 10, 20]"
    [pageSize]="10"
    showFirstLastButtons
  >
  </mat-paginator> -->
</div>
